import {createWebHistory, createRouter} from "vue-router";
import LayoutDashboard from "./views/layout/LayoutDashboard";
import LoginView from "./views/LoginView";
import UserListView from "./views/user/UserListView";
import {SystemRole} from "./utils/SystemRole";
import LayoutSimple from "./views/layout/LayoutSimple";
import ForbiddenView from "./views/ForbiddenView";
import NotFoundView from "./views/NotFoundView";
import ErrorView from "./views/ErrorView";
import ChangePasswordView from "./views/ChangePasswordView";
import LayoutPublic from "./views/layout/LayoutPublic";
import PublicView from "./views/public/PublicView";
import HorseListView from "./views/horse/horseList/HorseListView.vue";
import EventTypeListView from "@/views/dict/eventType/EventTypeListView.vue";
import BookTypeListView from "@/views/dict/booktype/BookTypeListView.vue";
import HorseColorListView from "@/views/dict/horsecolor/HorseColorListView.vue";
import OwnerListView from "@/views/owner/OwnerListView.vue";
import LaboratoryListView from "@/views/laboratory/LaboratoryListView.vue";
import HorseEditLayout from "@/views/horse/horseEdit/HorseEditLayout.vue";
import HorseEditMainView from "@/views/horse/horseEdit/main/HorseEditMainView.vue";
import HorseEditEventsView from "@/views/horse/horseEdit/HorseEditEventsView.vue";
import HorseEditCoveringView from "@/views/horse/horseEdit/HorseEditCoveringView.vue";
import HorseEditOffspringView from "@/views/horse/horseEdit/HorseEditOffspringView.vue";
import HorseEditLaboratoryView from "@/views/horse/horseEdit/laboratory/HorseEditLaboratoryView.vue";
import HorseEditDocumentsView from "@/views/horse/horseEdit/documents/HorseEditDocumentsView.vue";
import HorseEditHistoryView from "@/views/horse/horseEdit/history/HorseHistoryView.vue";
import ImportedHorseFormView from "@/views/horse/importHorse/ImportedHorseFormView.vue";
import FiltersView from "./views/filters/FiltersView.vue";
import HorsePendingView from "./views/pending/HorsePendingView.vue";
import StallionListView from "@/views/stallions/StallionListView.vue";
import BroodmareListView from "./views/broodmares/BroodmareListView.vue";
import FoalFormView from "@/views/horse/foal/FoalFormView.vue";
import LaboratoryHorseTestFormView from "@/views/pending/LaboratoryHorseTestFormView.vue";
import DocumentListView from "@/views/documents/DocumentListView.vue";
import ForbiddenNameListView from "@/views/dict/forbiddenName/ForbiddenNameListView.vue";
import DashboardView from "@/views/dashboard/DashboardView.vue";
import SeasonListView from "@/views/dict/season/SeasonListView.vue";
import ReadOnlyView from "@/views/readonly/ReadOnlyView.vue";
import StudbookPrintView from "@/views/readonly/studbook/StudbookPrintView.vue";
import ExportDocumentPrintView from "@/views/readonly/exportDocument/ExportDocumentPrintView.vue";
import HistoryListView from "@/views/history/HistoryListView.vue";

const routes = [
        {
            path: "/",
            name: "home",
            component: LayoutDashboard,
            meta: {requiresAuth: true},
            children: [
                {
                    path: "/home",
                    component: DashboardView,
                    name: "dashboardView",
                    alias: "/",
                    meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR, SystemRole.VIEWER]},
                },
                {
                    path: "/forbidden",
                    name: "forbidden",
                    component: ForbiddenView,
                },
                {
                    path: "/user",
                    meta: {role: [SystemRole.ADMIN]},
                    children: [
                        {
                            path: "list",
                            name: "userList",
                            component: UserListView,
                        },
                    ],
                },
                {
                    path: "/filters",
                    name: "filters",
                    component: FiltersView,
                    meta: {roles: [SystemRole.ADMIN, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR]},
                },
                {
                    path: "/laboratories",
                    meta: {roles: [SystemRole.ADMIN, SystemRole.LAB_USER]},
                    children: [
                        {
                            path: "list",
                            name: "laboratoryList",
                            component: LaboratoryListView,
                        },
                    ],
                },
                {
                    path: "/documents",
                    meta: {roles: [SystemRole.ADMIN, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR]},
                    children: [
                        {
                            path: "list",
                            name: "documentList",
                            component: DocumentListView,
                        },
                    ],
                },
                {
                    path: "/history",
                    meta: {roles: [SystemRole.ADMIN, SystemRole.FOURTH_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.FIRST_LEVEL_EDITOR]},
                    children: [
                        {
                            path: "list",
                            name: "historyList",
                            component: HistoryListView,
                        },
                    ],
                },
                {
                    path: "/laboratory/horses/form/:id",
                    name: "laboratoryHorseTestFormView",
                    component: LaboratoryHorseTestFormView,
                    meta: {roles: [SystemRole.ADMIN, SystemRole.LAB_USER]},
                },
                {
                    path: "/pending",
                    children: [
                        {
                            path: "list",
                            name: "pendingList",
                            component: HorsePendingView,
                            meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR, SystemRole.LAB_USER]},
                        },
                    ],
                },
                {
                    path: "/stallions",
                    meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR]},
                    children: [
                        {
                            path: "list",
                            name: "stallionList",
                            component: StallionListView,
                        },
                    ],
                },
                {
                    path: "/broodmares",
                    meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR]},
                    children: [
                        {
                            path: "list",
                            name: "broodmareList",
                            component: BroodmareListView,
                        },
                    ],
                },
                {
                    path: "/horse",
                    children: [
                        {
                            path: "list",
                            name: "horseList",
                            component: HorseListView,
                            meta: {roles: [SystemRole.ADMIN, SystemRole.VIEWER, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR]},
                        },
                        {
                            path: "import",
                            name: "newImportedHorse",
                            component: ImportedHorseFormView,
                            meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR]},
                            children: [
                                {
                                    path: ":id",
                                    name: "editImportedHorse",
                                    component: ImportedHorseFormView,
                                },
                            ],
                        },
                        {
                            path: "foal",
                            name: "newFoal",
                            component: FoalFormView,
                            meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR]},
                            children: [
                                {
                                    path: ":id",
                                    name: "editFoal",
                                    component: FoalFormView,
                                },
                            ],
                        },
                        {
                            path: "edit/:id",
                            name: "horseEdit",
                            component: HorseEditLayout,
                            children: [
                                {
                                    path: "",
                                    name: "horseEditMain",
                                    component: HorseEditMainView,
                                    meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR]},
                                },
                                {
                                    path: "events",
                                    name: "horseEditEvents",
                                    component: HorseEditEventsView,
                                    meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR]},
                                },
                                {
                                    path: "covering",
                                    name: "horseEditCovering",
                                    component: HorseEditCoveringView,
                                    meta: {roles: [SystemRole.ADMIN, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR]},
                                },
                                {
                                    path: "offspring",
                                    name: "horseEditOffspring",
                                    component: HorseEditOffspringView,
                                },
                                {
                                    path: "laboratory",
                                    name: "horseEditLaboratory",
                                    component: HorseEditLaboratoryView,
                                    meta: {roles: [SystemRole.ADMIN, SystemRole.THIRD_LEVEL_EDITOR]},
                                },
                                {
                                    path: "documents",
                                    name: "horseEditDocuments",
                                    component: HorseEditDocumentsView,
                                    meta: {roles: [SystemRole.ADMIN, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR, SystemRole.FOURTH_LEVEL_EDITOR]},
                                },
                                {
                                    path: "history",
                                    name: "horseEditHistory",
                                    component: HorseEditHistoryView,
                                    meta: {roles: [SystemRole.ADMIN, SystemRole.FOURTH_LEVEL_EDITOR]},
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "/event-type",
                    meta: {roles: [SystemRole.ADMIN]},
                    children: [
                        {
                            path: "list",
                            name: "eventTypeList",
                            component: EventTypeListView,
                        },
                    ],
                },
                {
                    path: "/book-type",
                    meta: {roles: [SystemRole.ADMIN]},
                    children: [
                        {
                            path: "list",
                            name: "studbookTypeList",
                            component: BookTypeListView,
                        },
                    ],
                },
                {
                    path: "/horse-color",
                    meta: {roles: [SystemRole.ADMIN]},
                    children: [
                        {
                            path: "list",
                            name: "horseColorList",
                            component: HorseColorListView,
                        },
                    ],
                },
                {
                    path: "/forbidden-name",
                    meta: {roles: [SystemRole.ADMIN]},
                    children: [
                        {
                            path: "list",
                            name: "forbiddenNameList",
                            component: ForbiddenNameListView,
                        },
                    ],
                },
                {
                    path: "/season",
                    meta: {roles: [SystemRole.ADMIN]},
                    children: [
                        {
                            path: "list",
                            name: "seasonList",
                            component: SeasonListView,
                        },
                    ],
                },
                {
                    path: "/owners-and-breeders",
                    meta: {roles: [SystemRole.ADMIN, SystemRole.FIRST_LEVEL_EDITOR, SystemRole.SECOND_LEVEL_EDITOR, SystemRole.THIRD_LEVEL_EDITOR]},
                    children: [
                        {
                            path: "list",
                            name: "ownerList",
                            component: OwnerListView,
                        },
                    ],
                },
                {
                    path: "/admin/import",
                    name: "import",
                    component: () => import("@/views/admin/ImportView.vue"),
                    meta: {roles: [SystemRole.ADMIN]},
                },
                {
                    path: "/admin/config",
                    name: "adminConfig",
                    component: () => import("@/views/admin/AdminConfigView.vue"),
                    meta: {roles: [SystemRole.ADMIN]},
                },
            ],
        },
        {
            component: LayoutPublic,
            path: "/",
            children: [
                {
                    path: "/",
                    name: "public",
                    component: PublicView,
                },
            ],
        },
    {
        name: "layoutSimple",
        component: LayoutSimple,
        path: "/",
        children: [
            {
                path: "/login",
                name: "login",
                component: LoginView,
            },
            {
                path: "/change-password",
                name: "changePassword",
                component: ChangePasswordView,
            },
            {
                path: "/forbidden",
                name: "forbidden",
                component: ForbiddenView,
            },
            {
                path: "/error",
                name: "error",
                component: ErrorView,
            },
            {
                path: "/:pathMatch(.*)*",
                name: "notFound",
                component: NotFoundView,
            },
        ],
    },
    {
        path: "/ouW4RsBuRDoXr75z/LrZ6iibDC2X8JlyuRuW4RqqTtS4Iii5sBuRD0djoXrRDC2X8uRDC2X8Jl0djoXr75zGeEUXh",
        name: "printView",
        component: ReadOnlyView,
        children: [
            {
                path: "studbook/:breed/:volume/:from/:to",
                name: "studbook",
                component: StudbookPrintView,
            },
            {
                path: "export-document/:breed/:id",
                name: "exportDocument",
                component: ExportDocumentPrintView,
            },
        ],
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
